import React from 'react'
// Material ui
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import EmailIcon from '@material-ui/icons/Email';
// App
import { history } from '../App'
import { FancyTextInput, FancyButton } from '../utils/FancyComponents'
import Logo from '../assets/media/tke.svg';
// Forms
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers';
import * as yup from "yup";
// Redux
import { useDispatch } from 'react-redux';
// Services
import { requestChangePassword } from '../services/AuthServices'
// Others
import { Link } from 'react-router-dom';
import axios, { CancelTokenSource } from 'axios';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      height: 60,
      width: 'auto'
    },
    linkPrimary: {
      textAlign: 'center',
      textDecoration: 'none',
      color: theme.palette.primary.main,
      fontSize: '1rem',
      '&:hover': {
        color: theme.palette.primary.dark,
      }
    },
    paper: {
      width: '350px',
      height: '100%',
      padding: theme.spacing(2, 3),
      [theme.breakpoints.down('xs')]: {
        width: 'auto',
        padding: theme.spacing(1, 2),
      }
    }
  }),
);

const schema = yup.object().shape({
  email: yup.string().required().email(),
});

let source: CancelTokenSource = axios.CancelToken.source();

export default function RestorePasswordForm() {
  const dispatch = useDispatch();
  const styles = useStyles();
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const [busy, setBusy] = React.useState(false);
  const { handleSubmit, control, errors } = methods;

  React.useEffect(() => {
    source = axios.CancelToken.source();
    return () => {
      source.cancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (userData: any) => {
    setBusy(true);
    requestChangePassword(userData, history, dispatch, source)
      .catch(error => {
        if (!error.isCanceled) {
          setBusy(false);
        }
      });
  }

  return (
    <Paper className={styles.paper}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container direction="row" justify="center" spacing={1}>
          <Grid item xs={12} container justify="center">
            <img src={Logo} alt="logo" className={styles.logo} />
          </Grid>
          <Grid item xs={12}>
            <Typography align="center" variant="h6" color="textSecondary">¿Deseas que te ayudemos con la contraseña?</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography align="center" variant="body2" color="textSecondary">
              Ingresa tu correo electrónico y te ayudaremos a crear una nueva contraseña.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Controller
              as={FancyTextInput}
              InputProps={{
                startAdornment: <InputAdornment position="start"><EmailIcon color="secondary" /></InputAdornment>,
              }}
              control={control}
              error={!!errors.email}
              helperText={errors.email && errors.email.message}
              defaultValue=""
              type="email"
              name="email"
              placeholder="Email"
            />
          </Grid>
          <Grid item xs={12} container direction="row" justify="center">
            <FancyButton
              variant="contained"
              color='primary'
              type="submit"
              disabled={busy}
              loading={busy}
            >
              Siguiente
            </FancyButton>
          </Grid>
          <Grid item xs={12} container direction="row" justify="center">
            <Typography component={Link} to='/' className={styles.linkPrimary}>
              Volver al inicio de sesión
            </Typography>
          </Grid>
        </Grid>
      </form>
    </Paper>
  )
}
